<!-- 首页 -->
<style scoped>
.box {
  width: 100%;
}
.box .title {
  width: 100%;
  height: 229px;
  background: #fff;
}
.box .title div {
  width: 1200px;
  height: 229px;
  box-sizing: border-box;
  padding: 60px 109px 0 109px;
  margin: 0 auto;
  text-align: center;
}
.box .title div h2 {
  font-size: 34px;
}
.box .title div p {
  margin-top: 32px;
  font-size: 18px;
  color: #666666;
  line-height: 26px;
}
.box .core {
  width: 100%;
  height: 586px;
  /*  padding-top: 42px; */
  position: relative;
  box-sizing: border-box;
  background: #f0f0f0;
}
.box .core .fater {
  position: absolute;
  top: 42px;
  left: 0;
  right: 0;
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  height: 621px;
}
.box .core .fater h2 {
  font-size: 34px;
  line-height: 34px;
  margin-bottom: 16px;
}
.box .core .fater .xian {
  width: 62px;
  height: 2px;
  background: #04a0f7;
  border: 1px solid #04a0f7;
  margin: 0 auto 40px;
}
.box .core .fater .images {
  width: 1200px;
  height: 528px;
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}
.box .core .fater .images .introduceBItem {
  display: inline-block;
  width: 288px;
  height: 530px;
  background-color: #ffffff;
  border-radius: 2px;
  border: 1px solid #e5e8ed;
  overflow: hidden;
}
.box .core .fater .images .introduceBItem img {
  width: 100%;
}
.box .core .fater .images .introduceBItem h1 {
  margin-top: 20px;
  text-align: center;
  color: #000000;
  font-size: 22px;
  margin-bottom: 10px;
}
.box .core .fater .images .introduceBItem p {
  position: relative;
  color: #666666;
  font-size: 14px;
  padding: 0 23px 0 30px;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  text-align: left;
}
.box .core .fater .images .introduceBItem p i {
  position: absolute;
  top: 0;
  left: 20px;
  display: inline-block;
  line-height: 26px;
}
.box .core .fater .images .introduceBItem p span {
  line-height: 24px;
}
.box .core .fater .images .introduceBItem {
  animation: dontSelectionPlay .2s forwards;
  -webkit-animation: dontSelectionPlay .2s forwards;
}
.box .core .fater .images .introduceBItem:hover {
  box-shadow: 10px 0 10px #f4f6f8,-10px 0 10px #f4f6f8,0 10px 10px #f4f6f8,0 -10px 10px #f4f6f8;
  -webkit-box-shadow: 10px 0 10px #f4f6f8,-10px 0 10px #f4f6f8,0 10px 10px #f4f6f8,0 -10px 10px #f4f6f8;
  animation: selectionPlay .2s forwards;
  -webkit-animation: selectionPlay .2s forwards;
}
.box .advantage {
  width: 100%;
  height: 657px;
  box-sizing: border-box;
  padding-top: 139px;
  background: url(../../assets/images/ban_02.png) center center;
}
.box .advantage .advantageItem {
  animation: dontSelectionPlay .2s forwards;
  -webkit-animation: dontSelectionPlay .2s forwards;
}
.box .advantage .advantageItem:hover {
  box-shadow: 10px 0 10px #f4f6f8,-10px 0 10px #f4f6f8,0 10px 10px #f4f6f8,0 -10px 10px #f4f6f8;
  -webkit-box-shadow: 10px 0 10px #f4f6f8,-10px 0 10px #f4f6f8,0 10px 10px #f4f6f8,0 -10px 10px #f4f6f8;
  animation: selectionPlay .2s forwards;
  -webkit-animation: selectionPlay .2s forwards;
}
.box .advantage .box {
  width: 1200px;
  margin: 0 auto;
  height: 458px;
  text-align: center;
}
.box .advantage .box h2 {
  line-height: 34px;
  font-size: 34px;
  margin-bottom: 16px;
}
.box .advantage .box .xian {
  width: 62px;
  height: 2px;
  background: #04a0f7;
  border: 1px solid #04a0f7;
  margin: 0 auto 33px;
}
.box .advantage .box .images {
  width: 1200px;
  height: 372px;
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-content: space-between;
}
.box .advantage .advantageItem {
  display: -webkit-inline-flex;
  display: inline-flex;
  width: 230px;
  height: 180px;
  border: 1px solid #e5e8ed;
  border-radius: 5px;
  background-color: #ffffff;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
}
.box .advantage .advantageItem img {
  display: block;
  width: 81px;
  height: 62px;
  margin: 0 auto;
}
.box .advantage .advantageItem p {
  margin-top: 25px;
  color: #000000;
  font-size: 16px;
  line-height: 22px;
}
.box .bg {
  position: relative;
  width: 100%;
  height: 1160px;
}
.box .bg .bgA {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 451px;
  background-color: #f0f0f0;
}
.box .bg .bgB {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 709px;
  background: url(../../assets/images/indexbg.png)no-repeat center center;
}
.box .programme {
  /* background: #f0f0f0; */
  width: 100%;
  position: relative;
  /* height: 452px; */
}
.box .programme .box {
  width: 1200px;
  padding-top: 40px;
  /* height: 492px; */
  margin: 0 auto;
  text-align: center;
}
.box .programme .box .choice {
  width: 1200px;
  height: 32px;
  margin-top: 30px;
  border-bottom: 1px solid #d1d1d1;
  position: relative;
}
.box .programme .box .choice img {
  position: absolute;
  bottom: -1px;
}
.box .programme .box .choice div {
  float: left;
  margin-left: 101px;
  width: 172px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  font-size: 16px;
  color: #000;
  cursor: pointer;
}
.box .programme .box .choice div.selectionItem {
  color: #28a6f7;
}
.box .programme .box .choice div:hover {
  color: #28a6f7;
}
.box .programme .box .images {
  position: relative;
}
/* .box .programme .box .images div {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
} */
.box .programme .box .images div p {
  margin-top: 15px;
  font-size: 18px;
  color: #666666;
}
.box .programme .box .images div section {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.box .programme .box .images div section .tabItemBox {
  display: inline-block;
  width: 288px;
  height: 326px;
  padding: 15px;
  background-color: #ffffff;
  text-align: left;
  border-radius: 2px;
  box-shadow: 0 5px 5px #eff2f5,0 -5px 5px #eff2f5,-5px 0 5px #eff2f5;
  -webkit-box-shadow: 0 5px 5px #eff2f5,0 -5px 5px #eff2f5,-5px 0 5px #eff2f5;
}
.box .programme .box .images div section .tabItemBox {
  animation: dontSelectionPlay .2s forwards;
  -webkit-animation: dontSelectionPlay .2s forwards;
}
.box .programme .box .images div section .tabItemBox:hover {
  animation: selectionPlay .2s forwards;
  -webkit-animation: selectionPlay .2s forwards;
  box-shadow: 10px 0 10px #f4f6f8,-10px 0 10px #f4f6f8,0 10px 10px #f4f6f8,0 -10px 10px #f4f6f8;
  -webkit-box-shadow: 10px 0 10px #f4f6f8,-10px 0 10px #f4f6f8,0 10px 10px #f4f6f8,0 -10px 10px #f4f6f8;
}
.box .programme .box .images div section .tabItemBox h1 i {
  display: inline-block;
  vertical-align: middle;
}
.box .programme .box .images div section .tabItemBox h1 i.tabAIcon1 {
  width: 30px;
  height: 24px;
  background-image: url(../../assets/images/tabAIcon1.png);
}
.box .programme .box .images div section .tabItemBox h1 i.tabAIcon2 {
  width: 30px;
  height: 28px;
  background-image: url(../../assets/images/tabAIcon2.png);
}
.box .programme .box .images div section .tabItemBox h1 i.tabAIcon3 {
  width: 30px;
  height: 26px;
  background-image: url(../../assets/images/tabAIcon3.png);
}
.box .programme .box .images div section .tabItemBox h1 i.tabAIcon4 {
  width: 26px;
  height: 26px;
  background-image: url(../../assets/images/tabAIcon4.png);
}
.box .programme .box .images div section .tabItemBox h1 i.tabBIcon1 {
  width: 30px;
  height: 26px;
  background-image: url(../../assets/images/tabBIcon1.png);
}
.box .programme .box .images div section .tabItemBox h1 i.tabBIcon2 {
  width: 28px;
  height: 26px;
  background-image: url(../../assets/images/tabBIcon2.png);
}
.box .programme .box .images div section .tabItemBox h1 i.tabBIcon4 {
  width: 26px;
  height: 26px;
  background-image: url(../../assets/images/tabBIcon4.png);
}
.box .programme .box .images div section .tabItemBox h1 span {
  margin-left: 11px;
  vertical-align: middle;
  color: #000000;
  font-size: 18px;
}
.box .programme .box .images div section .tabItemBox .tips {
  margin-top: 10px;
  color: #666666;
  line-height: 24px;
  font-size: 14px;
  height: auto;
}
.box .programme .box .images div section .tabItemBox h2 {
  margin-top: 15px;
  color: #000000;
  font-size: 16px;
}
.box .programme .box .images div section .tabItemBox .list {
  margin-top: 15px;
}
.box .programme .box .images div section .tabItemBox .item {
  color: #666666;
  font-size: 14px;
  line-height: 24px;
}
.box .user {
  position: relative;
  width: 100%;
  height: 709px;
  box-sizing: border-box;
  padding-top: 40px;
}
.box .user .box {
  width: 1200px;
  height: 568px;
  text-align: center;
  margin: 0 auto;
}
.box .user .box h2 {
  line-height: 34px;
  font-size: 34px;
  margin-bottom: 16px;
}
.box .user .box .xian {
  width: 62px;
  height: 2px;
  background: #04a0f7;
  border: 1px solid #04a0f7;
  margin: 0 auto 33px;
}
.box .user .box p {
  margin-top: 20px;
  font-size: 18px;
  text-align: 18px;
  color: #666666;
}
.box .user .userContent {
  position: relative;
  width: 100%;
  margin-top: 30px;
}
.box .user .userContent .userImg {
  width: 660px;
  height: 382px;
  animation: dontSelectionPlay .2s forwards;
  -webkit-animation: dontSelectionPlay .2s forwards;
}
.box .user .userContent .userImg:hover {
  animation: selectionPlay .2s forwards;
  -webkit-animation: selectionPlay .2s forwards;
}
.box .user .userContent .userImg img {
  width: 100%;
}
.box .user .userContent .tipsBox {
  position: absolute;
  top: 30px;
  right: 0;
  width: 650px;
  padding: 100px 0 75px;
  background-color: #ffffff;
  text-align: center;
  animation: dontSelectionPlay .2s forwards;
  -webkit-animation: dontSelectionPlay .2s forwards;
}
.box .user .userContent .tipsBox:hover {
  animation: selectionPlay .2s forwards;
  -webkit-animation: selectionPlay .2s forwards;
}
.box .user .userContent .tipsBox p {
  text-align: center;
  color: #000000;
  font-size: 20px;
}
.box .user .userContent .tipsBox a {
  display: inline-block;
  margin-top: 40px;
  padding: 20px;
  color: #ffffff;
  font-size: 20px;
  background-image: -webkit-linear-gradient(to right, #2b7bff , #04a0f7);
  background-image: -moz-linear-gradient(to right, #2b7bff , #04a0f7);
  background-image: -o-linear-gradient(to right, #2b7bff , #04a0f7);
  background-image: linear-gradient(to right, #2b7bff , #04a0f7);
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}
</style>
<template>
  <div class="box">
    <div class="block">
      <banner></banner>
    </div>
    <div class="title">
      <div>
        <h2>彩讯5G新消息平台</h2>
        <p>
          彩讯5G新信息平台是连接行业客户与底层消息中心，通过对内容、消息、任务<br />的综合管理实现5G消息的场景化下发，助力行业客户实现消息场景升级。
        </p>
      </div>
    </div>
    <div class="core">
      <div class="fater">
        <modularTit :titleName="'核心能力'"></modularTit>
        <!-- <h2>核心能力</h2>
        <div class="xian"></div> -->
        <div class="images">
          <div class="introduceBItem">
            <img src="@/assets/images/1.png" alt="" />
            <h1>行业场景模板库</h1>
            <p><i>·</i><span>面向多个行业提供常用场景模板，行业内客户可快速调用，实现5G消息服务快速商用。</span></p>
            <!-- <p><i>·</i><span>提供模板消息，模板融合图片合成功能，支持客户快速调用。</span></p> -->
          </div>
          <div class="introduceBItem">
            <img src="@/assets/images/2.png" alt="" />
            <h1>行业智能应答（chatbot）</h1>
            <p><i>·</i><span>面向垂直行业提供标准版chatbot解决方案，提供智能应答和知识库补充更新。</span></p>
            <p><i>·</i><span>支持客户的成熟机器人能力以API形式接入平台。</span></p>
          </div>
          <div class="introduceBItem">
            <img src="@/assets/images/3.png" alt="" />
            <h1>消息发送确保到达</h1>
            <p><i>·</i><span>提供多种短信兼容方案，保障触达所有终端用户。</span></p>
            <p><i>·</i><span>支持自动将5G消息封装成H5页面，实现所有终端用户都能体验5G消息。</span></p>
          </div>
          <div class="introduceBItem">
            <img src="@/assets/images/4.png" alt="" />
            <h1>实用后台便捷管理</h1>
            <p><i>·</i><span>免费申请即时审核，快速开通企业5G消息服务。</span></p>
            <p><i>·</i><span>多重智能+人工安全校验审核机制，保障服务合法合规。</span></p>
            <p><i>·</i><span>可视化运营管理，传播及转化效能，一目了然。</span></p>
          </div>
          <!-- <img src="@/assets/images/1.png" alt="" />
          <img src="@/assets/images/2.png" alt="" />
          <img src="@/assets/images/3.png" alt="" />
          <img src="@/assets/images/4.png" alt="" /> -->
        </div>
      </div>
    </div>
    <div class="advantage">
      <div class="box">
        <modularTit :titleName="'平台优势'"></modularTit>
        <!-- <h2>平台优势</h2>
        <div class="xian"></div> -->
        <div class="images">
          <div class="advantageItem">
            <div>
              <img src="@/assets/images/advantageIcon1.png" />
              <p>海量行业模板<br />便捷调用</p>
            </div>
          </div>
          <div class="advantageItem">
            <div>
              <img src="@/assets/images/advantageIcon2.png" />
              <p>多样化增值服务<br />自助订购</p>
            </div>
          </div>
          <div class="advantageItem">
            <div>
              <img src="@/assets/images/advantageIcon3.png" />
              <p>场景化消息下发<br />满足各式需求</p>
            </div>
          </div>
          <div class="advantageItem">
            <div>
              <img src="@/assets/images/advantageIcon4.png" />
              <p>多维度数据分析<br />助力运营</p>
            </div>
          </div>
          <div class="advantageItem">
            <div>
              <img src="@/assets/images/advantageIcon5.png" />
              <p>上百种H5模板库<br />便捷应用</p>
            </div>
          </div>
          <div class="advantageItem">
            <div>
              <img src="@/assets/images/advantageIcon6.png" />
              <p>三级回落机制<br />保障消息覆盖率</p>
            </div>
          </div>
          <div class="advantageItem">
            <div>
              <img src="@/assets/images/advantageIcon7.png" />
              <p>开放API<br />支持接口对接</p>
            </div>
          </div>
          <div class="advantageItem">
            <div>
              <img src="@/assets/images/advantageIcon8.png" />
              <p>上下行消息全量记录<br />支持回溯</p>
            </div>
          </div>
          <div class="advantageItem">
            <div>
              <img src="@/assets/images/advantageIcon9.png" />
              <p>垂直行业chatbot解决方案<br />应用快捷</p>
            </div>
          </div>
          <div class="advantageItem">
            <div>
              <img src="@/assets/images/advantageIcon10.png" />
              <p>Chatbot AI行业知识库<br />智能问答</p>
            </div>
          </div>
          <!-- <img src="@/assets/images/b1_09.png" alt="" />
          <img src="@/assets/images/b2_09.png" alt="" />
          <img src="@/assets/images/b3_09.png" alt="" />
          <img src="@/assets/images/b4_09.png" alt="" />
          <img src="@/assets/images/b5_09.png" alt="" />
          <img src="@/assets/images/b6_09.png" alt="" />
          <img src="@/assets/images/b7_09.png" alt="" />
          <img src="@/assets/images/b8_09.png" alt="" />
          <img src="@/assets/images/b9_09.png" alt="" />
          <img src="@/assets/images/b10_09.png" alt="" /> -->
        </div>
      </div>
    </div>
    <div class="bg">
      <div class="bgA"></div>
      <div class="bgB"></div>
      <div class="programme">
        <div class="box">
          <modularTit :titleName="'行业方案'"></modularTit>
          <div class="choice">
            <div
              @click="handleClick(0)" 
              :class="{'selectionItem': tabNumer == 0}"
            >
              金融
            </div>
            <div
              @click="handleClick(1)" 
              :class="{'selectionItem': tabNumer == 1}"
            >
              交通
            </div>
            <div
              @click="handleClick(2)" 
              :class="{'selectionItem': tabNumer == 2}"
            >
              互联网
            </div>
            <div
              @click="handleClick(3)" 
              :class="{'selectionItem': tabNumer == 3}"
            >
              电力
            </div>
            <img
              src="@/assets/images/22_14.png"
              alt=""
              :style="{ left: activeName + 'px' }"
            />
          </div>
          <div class="images">
            <div>
              <!-- <p>{{tabList[tabNumer].tips}}</p> -->
              <section>
                <div 
                  class="tabItemBox" 
                  v-for="(item,index) in tabList[tabNumer].dataList" 
                  :key="index">
                  <h1><i :class="item.classN"></i><span>{{item.title}}</span></h1>
                  <p class="tips">{{item.tips}}</p>
                  <h2>{{item.labelTitle}}</h2>
                  <ul 
                    class="list">
                    <li 
                      class="item" 
                      v-for="(item1,index1) in item.labelList" 
                      :key="index1">·&nbsp;{{item1}}</li>
                  </ul>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <div class="user">
        <div class="box">
          <modularTit :titleName="'申请试用'"></modularTit>
          <!-- <h2>申请试用</h2>
          <div class="xian"></div> -->
          <p>选择彩讯5G新消息平台，构建企业5G消息应用场景，助力行业客户实现消息场景化升级</p>
          <div class="userContent">
              <div class="userImg">
                <img src="@/assets/images/n1_14.png" />
              </div>
              <div class="tipsBox">
                <p>即刻成为开发者，赋能企业服务客户能力，开启5G消息应用新时代。</p>
                <a href="http://5gm.richinfo.cn/dist/index.html#/register" target="_blank">免费试用，成为开发者</a>
              </div>
          </div>
        </div>
      </div>
    </div>
    <introduce></introduce>
  </div>
</template>
<script>
import modularTit from '@/components/modularTit'
import banner from '@/components/banner'
import introduce from "@/components/introduce.vue"
export default {
  components: {
    banner,
    modularTit,
    introduce
  },
  data() {
    return {
      activeName: 101,
      tabNumer: 0,
      tabList: [
        {
          name: '金融',
          // tips: '5G消息在智慧银行的应用，除了能够提供基础的P2P消息场景（如银行客户经理与客户之间通过5G消息进行富媒体沟通），在行业消息A2P方面的应用场景还可以分为以下几类：',
          dataList: [
            {
              title: '消息通知',
              classN: 'tabAIcon1',
              tips: '消息通知的场景主要是向用户发送的各类通知消息，消息的形式一般以文字、图片、视频等内容为主',
              labelTitle: '场景举例：',
              labelList: [
                '余额变动提醒',
                '广告营销信息推送',
                '工资到账通知',
                '信用卡还款通知',
                '个人贷款还款通知'
              ]
            },
            {
              title: '信息查询',
              classN: 'tabAIcon2',
              tips: '用户主动发起的基于关键字、语音或标签的信息查询，银行系统可通过用户发送的信息进行智能识别，并作出下一步信息反馈',
              labelTitle: '场景举例：',
              labelList: [
                '余额、账单查询',
                '网点信息查询',
                '收支明细查询',
                '交易查询'
              ]
            },
            {
              title: '自助业务办理',
              classN: 'tabAIcon3',
              tips: '用户通过银行系统提供的自助流程引导，进行的在线业务办理',
              labelTitle: '场景举例：',
              labelList: [
                '新开信用卡办理',
                '分期业务办理',
                '理财产品购买',
                '生活缴费服务',
                '风险评估'
              ]
            },
            {
              title: '客服服务',
              classN: 'tabAIcon4',
              tips: '基于人工智能客服或人工客服坐席向用户提供业务办理、信息查询、业务咨询、投诉等服务响应',
              labelTitle: '场景举例：',
              labelList: [
                '955xx智能消息客服',
                '955xx贵宾消息客服'
              ]
            }
          ]
        },
        {
          name: '互联网',
          // tips: '',
          dataList: [
            {
              title: '消息通知',
              classN: 'tabAIcon1',
              tips: '消息通知的场景主要是由平台向用户发送的各类通知消息，消息的形式一般以文字、图片、视频等内容为主',
              labelTitle: '场景案例：',
              labelList: [
                '政府部门发送给市民的大量通知和服务',
                '移动欠费提醒通知',
                '物业催费通知',
                '保险业务到期续费通知'
              ]
            },
            {
              title: '信息查询',
              classN: 'tabAIcon2',
              tips: '用户主动发起的基于关键字、语音或标签的信息查询，平台可通过用户发送的信息进行智能识别，并作出下一步信息反馈',
              labelTitle: '场景案例：',
              labelList: [
                '航班信息查询',
                '移动话费余额查询',
                '订票信息查询',
                '物流单号查询'
              ]
            },
            {
              title: '自助业务办理',
              classN: 'tabAIcon3',
              tips: '用户通过平台提供的自助流程引导，进行的在线业务办理',
              labelTitle: '场景案例：',
              labelList: [
                '移动流量套餐办理',
                '政务业务自主办理',
                '银行业务办理'
              ]
            },
            {
              title: '客服响应',
              classN: 'tabBIcon4',
              tips: '基于人工智能客服或人工客服坐席向用户提供咨询、投诉、报警等服务响应',
              labelTitle: '场景案例：',
              labelList: [
                '120、110、119短信报警坐席响应'
              ]
            }
          ]
        },
        {
          name: '交通',
          // tips: '',
          dataList: [
            {
              title: '营销服务',
              classN: 'tabBIcon1',
              tips: '互联网企业客户主动向用户发送的各类营销类消息，消息的形式一般以文字、图片、视频等内容为主。',
              labelTitle: '场景举例：',
              labelList: [
                '各类活动通知',
                '优惠券/福利/礼包发放',
                '签到有礼',
                '官网登录入口、APP下载入口'
              ]
            },
            {
              title: '服务消息通知',
              classN: 'tabBIcon2',
              tips: '互联网企业客户主动向用户发送的各类通知服务类消息，消息的形式一般以文字、图片、视频等内容为主。',
              labelTitle: '场景举例：',
              labelList: [
                '行业资讯',
                '行业技能学习',
                '业务办理进度提醒'
              ]
            },
            {
              title: '自助业务办理',
              classN: 'tabAIcon3',
              tips: '用户通过5G消息号提供的自助流程引导，进行的在线业务办理。',
              labelTitle: '场景举例：',
              labelList: [
                '在线充值',
                '积分查询和兑换',
                '产品&服务购买',
                '联系商家客服',
                '退货退款'
              ]
            },
            {
              title: '客服服务',
              classN: 'tabBIcon4',
              tips: '用户主动发起的基于关键字、语音或标签的信息查询、服务咨询，人工智能客服或人工客服向用户提供各类服务响应。',
              labelTitle: '场景举例：',
              labelList: [
                '查询物流信息',
                '投诉建议&问题反馈',
                '智能消息客服'
              ]
            }
          ]
        },
        {
          name: '电力',
          // tips: '5G新消息在电力行业的应用，除了能够提供基础的P2P消息场景（如客服与客户之间通过5G新消息进行富媒体沟通），在行业消息A2P方面的应用场景还可以分为以下几类：',
          dataList: [
            {
              title: '消息通知',
              classN: 'tabAIcon1',
              tips: '消息通知的场景主要是向用户发送的各类通知消息，消息的形式一般以文字、图片、视频等内容为主',
              labelTitle: '场景举例：',
              labelList: [
                '缴费信息提醒',
                '停电信息推送',
                '政策信息推送',
                '业务预约进度通知'
              ]
            },
            {
              title: '信息查询',
              classN: 'tabAIcon2',
              tips: '用户主动发起的基于关键字、语音或标签的信息查询，系统可通过用户发送的信息进行智能识别，并作出下一步信息反馈',
              labelTitle: '场景举例：',
              labelList: [
                '电费账单查询',
                '网点信息查询',
                '缴费记录查询',
                '电价信息查询'
              ]
            },
            {
              title: '自助业务办理',
              classN: 'tabAIcon3',
              tips: '用户通过系统提供的自助流程引导，进行的在线业务办理',
              labelTitle: '场景举例：',
              labelList: [
                '故障报修',
                '远程开户',
                '用电报装',
                '欠费复电',
                '用电变更预约',
                '电子发票开具'
              ]
            },
            {
              title: '客服服务',
              classN: 'tabAIcon4',
              tips: '基于人工智能客服或人工客服坐席向用户提供业务办理、信息查询、业务咨询、投诉等服务响应',
              labelTitle: '场景举例：',
              labelList: [
                '955xx客服',
                '投诉与建议'
              ]
            }
          ]
        }
      ]
    };
  },
  methods: {
    handleClick(tab) {
      this.tabNumer = tab;
      let b = tab + 1;
      let a = 101 * b + 172 * tab;
      this.activeName = a;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/home/index.vue